export default __webpack_public_path__ + "static/media/colorpop.a0e442ad.jpg";